import React, { Component } from "react";
import { observer } from "mobx-react";
import LayerStore from "../../../../stores/LayerStore";
import img1 from "../../../../static-file/images/step04_img1.png";
import img2 from "../../../../static-file/images/step04_img2.png";
import img3 from "../../../../static-file/images/step04_img3.png";
import img4 from "../../../../static-file/images/step04_img4.png";
import img5 from "../../../../static-file/images/step04_img5.png";
import img6 from "../../../../static-file/images/step04_img6.png";
import img7 from "../../../../static-file/images/step04_img7.png";
import pre_btn from "../../../../static-file/images/pre_btn.png";
import pre_btn_black from "../../../../static-file/images/pre_btn_black.png";
import next_btn from "../../../../static-file/images/next_btn.png";
import next_btn_black from "../../../../static-file/images/next_btn_black.png";
import next_btn_gray from "../../../../static-file/images/next_btn_gray.png";
import BlankIcon from "../../../../static-file/images/logo/blank.png";

@observer
class OnboardingStep_04 extends Component {
  constructor(props) {
    super(props);
    this.state = { cnt: 1 };
    this.rootStore = {
      layerStore: LayerStore,
    };
  }

  cntUp = () => {
    const { rootStore } = this;
    if (this.state.cnt < 7) {
      this.setState({ cnt: this.state.cnt + 1 });
    }
  };

  cntDown = () => {
    const { rootStore } = this;
    if (this.state.cnt > 1) {
      this.setState({ cnt: this.state.cnt - 1 });
    } else {
      rootStore.layerStore.setChangeOnboardingStep("03");
      this.setState({ cnt: 1 });
    }
  };

  render() {
    const { rootStore } = this.props;
    const layerStore = rootStore.layerStore;

    let img = BlankIcon;
    let prev_icon = BlankIcon;
    let next_icon = BlankIcon;

    if (this.state.cnt === 1) {
      img = img1;
      prev_icon = pre_btn_black;
      next_icon = next_btn;
    } else if (this.state.cnt === 2) {
      img = img2;
      prev_icon = pre_btn;
      next_icon = next_btn;
    } else if (this.state.cnt === 3) {
      img = img3;
      prev_icon = pre_btn;
      next_icon = next_btn;
    } else if (this.state.cnt === 4) {
      img = img4;
      prev_icon = pre_btn;
      next_icon = next_btn;
    } else if (this.state.cnt === 5) {
      img = img5;
      prev_icon = pre_btn;
      next_icon = next_btn;
    } else if (this.state.cnt === 6) {
      img = img6;
      prev_icon = pre_btn;
      next_icon = next_btn;
    } else if (this.state.cnt === 7) {
      img = img7;
      prev_icon = pre_btn;
      next_icon = next_btn_gray;
    } else {
      img = BlankIcon;
    }

    return (
      <div
        className={"layer_comm layer_common_type " + (layerStore.getChangeOnboardingStep === "04" ? " layer_open" : "")}
      >
        <div className="bg"></div>
        <div className="layer_content">
          <div className="article_common_type">
            <div className="section">
              <div className="detail">
                <div className="top">
                  <span
                    className="top_txt"
                    onClick={event => {
                      layerStore.setChangeOnboardingStep("");
                      layerStore.setLayerOnboardingView(true);
                      this.setState({ cnt: 1 });
                    }}
                  >
                    &lt; &nbsp; 처음으로
                  </span>
                  <span className="top_sub">&nbsp;&nbsp;&nbsp;Step 04. 매출 자동 집계 설정</span>
                </div>
                <div className={this.state.cnt === 1 ? "tit" : "hide"}>
                  <p className="num">
                    <span>안내</span>
                  </p>
                  <p className="txt">
                    <strong>주문 자동완료 설정시,</strong> 포스에서 <strong>라이더 호출이 불가</strong>합니다.
                    <br />
                    <strong>"라이더 호출 없이 매출 합산"</strong>만 원하는 경우에 설정하세요
                  </p>
                </div>
                <div className={this.state.cnt === 2 ? "tit" : "hide"}>
                  <p className="num">
                    <span>1</span>
                  </p>
                  <p className="txt">
                    <strong>[사이드메뉴 &gt; 설정 &gt; 주문접수 설정]</strong>을 순서대로 클릭해주세요.
                  </p>
                </div>
                <div className={this.state.cnt === 3 ? "tit" : "hide"}>
                  <p className="num">
                    <span>2</span>
                  </p>
                  <p className="txt">
                    외부 주문접수 채널별로 <strong>자동 완료 처리 기능을 설정</strong>해줍니다.
                    <br />
                    <em>(사용 설정시, 주문이 바로 완료건으로 처리되면서 매출처리 됩니다)</em>
                  </p>
                </div>
                <div className={this.state.cnt === 4 ? "tit" : "hide"}>
                  <p className="num">
                    <span>3</span>
                  </p>
                  <p className="txt">
                    자동 완료처리 기능을 사용하는 경우,<strong> 사용방법 안내</strong>드려요!
                    <br />
                    배달앱 <strong>주문을 접수</strong>하여 고객용 <strong>주문서를 출력</strong>합니다.
                  </p>
                </div>
                <div className={this.state.cnt === 5 ? "tit" : "hide"}>
                  <p className="num">
                    <span>4</span>
                  </p>
                  <p className="txt">
                    출력된 주문서가 인식되면 <strong>해당 주문이 자동 완료 처리</strong>됩니다.
                  </p>
                </div>
                <div className={this.state.cnt === 6 ? "tit" : "hide"}>
                  <p className="num">
                    <span>5</span>
                  </p>
                  <p className="txt">
                    완료 주문은 <strong>[사이드메뉴 &gt; 지난주문내역]에서 확인</strong>할 수 있습니다.
                    <br />
                    <strong>매출 취소</strong>가 필요한 경우, <strong>지난주문내역에서 진행</strong>해주세요.
                  </p>
                </div>
                <div className={this.state.cnt === 7 ? "tit" : "hide"}>
                  <p className="num">
                    <span>6</span>
                  </p>
                  <p className="txt">
                    더 자세한 사항은 <strong>모바일 매뉴얼</strong>을 확인해주세요.
                  </p>
                </div>
                <div className="content">
                  <p className="pre">
                    <span className="btn" onClick={this.cntDown}>
                      <img src={prev_icon} alt={"prevButton"} />
                    </span>
                    <span className={this.state.cnt === 1 ? "txt" : "hide"}>이전 안내</span>
                  </p>
                  <p className="img">
                    <img src={img} alt={"content"} />
                  </p>
                  <p className="next">
                    <span className="btn" onClick={this.cntUp}>
                      <img src={next_icon} alt={"nextButton"} />
                    </span>
                    {/* <span className={(this.state.cnt===7?'txt':'hide')}>다음 안내</span> */}
                  </p>
                </div>
                <div className="page">
                  <ul className="pagination modal">
                    <li className={this.state.cnt === 1 ? "location" : "num"}></li>
                    <li className={this.state.cnt === 2 ? "location" : "num"}></li>
                    <li className={this.state.cnt === 3 ? "location" : "num"}></li>
                    <li className={this.state.cnt === 4 ? "location" : "num"}></li>
                    <li className={this.state.cnt === 5 ? "location" : "num"}></li>
                    <li className={this.state.cnt === 6 ? "location" : "num"}></li>
                    <li className={this.state.cnt === 7 ? "location" : "num"}></li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="btn_close">
              <button
                onClick={event => {
                  layerStore.setChangeOnboardingStep("");
                  this.setState({ cnt: 1 });
                }}
              >
                <span>닫기</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default OnboardingStep_04;
